import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ISyncOnboardingEditItem, ISyncOnboarding } from '../../fi-onboarding';
import { ControlValueAccessorValidatorBase } from '@fi-app/shared/control-value-accessor-validator-base';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FiOnboardingDisplayType } from '../../../fi-onboarding-enums';

@Component({
    selector: 'fi-onboarding-connect-edit-activate-tab',
    templateUrl: './fi-activate-tab.component.html',
    styleUrls: ['./fi-activate-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-onboarding-connect-edit-activate-tab' },
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiActivateTabComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiActivateTabComponent,
            multi: true,
        },
    ],
})
export class FiActivateTabComponent extends ControlValueAccessorValidatorBase<ISyncOnboardingEditItem> {
    @Input() selectedOnboardings: ISyncOnboarding[] = [];

    protected canActivate(): boolean {
        return this.selectedOnboardings.every((onboarding) => onboarding.IsShared);
    }

    protected readonly FiOnboardingDisplayType = FiOnboardingDisplayType;
}
